import {Button, Container, FormControl, TextField} from "@mui/material";
import React, {useState} from "react";
import logo from '../../img/spca-sc.png';
import FunctionsData from "../../Functions/FunctionsData";

/*
    This is the login page for vets. It's a simple form that takes a username and password, and then sends it to the server
    for validation. If the validation is successful, the server will return a token that is stored in the session storage.
 */
export default function Login() {

    const [un, setUn] = useState('');
    const [pw, setPw] = useState('');
    const [err, setErr] = useState('');
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    async function onClick(e) {

        e.preventDefault();
        const tkn = await FunctionsData.getCSRFToken();
        let postVars = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                username:un.toLowerCase().trim(),
                password: pw.trim(),
                'X-CSRF-Token':tkn.csrf
            })
        };

        await fetch(FunctionsData.getApiUrl("/api/search/authenticate/vet"), postVars)
            .then(response => response.json())
            .then((res) => {
                try {
                    if (res.valid > 0) {
                        localStorage.setItem("vTkn", res.token);
                        window.gtag('event', 'action', {
                            category: 'Vet',
                            action: 'Vet logged in'
                        });
                        window.location.reload();
                    } else {
                        setErr('Username / password combination is invalid.');
                        window.gtag('event', 'action', {
                            category: 'Vet',
                            action: 'Vet login failure'
                        });
                    }
                } catch (e) {

                    setErr('Username / password combination is invalid.');
                    window.gtag('event', 'action', {
                        category: 'Vet',
                        action: 'Vet login failure'
                    });
                }


            })

    }

    if(showForgotPassword === true) return (<ShowForgotPassword setShowForgotPassword={setShowForgotPassword} />);
    return (
        <div className={"content"}>
            <Container maxWidth="sm" sx={{ bgcolor: 'transparent', padding:5, marginTop:5}}>
                <img src={logo} />
                <div className={"login-form"}>
                    <form onSubmit={onClick}>
                        <h1 style={{marginTop:20,marginBottom:40,color:'#1565C0', textAlign:'left'}}>Vet login</h1>
                        <FormControl fullWidth sx={{marginBottom: 1}}>
                            <TextField
                                label="Username"
                                type="text"
                                value={un}
                                onChange={(e) => setUn(e.target.value)}
                                focused
                                autoComplete={"current-user"}
                            />
                        </FormControl>
                        <FormControl fullWidth sx={{marginBottom: 1}}>
                            <TextField
                                label="Password"
                                type="password"
                                value={pw}
                                onChange={(e) => setPw(e.target.value)}
                                focused
                                autoComplete={"current-password"}
                            />
                        </FormControl>
                        {(err !== '') ? <div style={{color:'red'}}>{err}</div> : null}
                        <Button
                            type={"submit"}
                            size="small" sx={{
                            fontSize:"1em",
                            fontWeight:600,
                            marginLeft:1,
                            m: 1
                        }} variant="contained"
                        >
                            Login
                        </Button>
                    </form>
                    <div style={{marginTop:10}}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            setShowForgotPassword(true);
                        }}>Forgot your password?</a>
                    </div>
                </div>
            </Container>
            <a href={
                (window.location.hostname.includes('spcadesexing.nz')) ? "https://register.spcadesexing.nz" : "https://register.spcadesexingtest.nz"
            } rel={"noreferrer"} style={{marginTop:10, textDecoration:'none' }}>Don't have an account? Sign up here.</a>
        </div>
    )

}

/*
    This is the forgot password page. It's a simple form that takes an email address, and then sends it to the server
    for validation. If the validation is successful, the server will send an email to the user with a link to reset
    their password.
 */
const ShowForgotPassword = ({setShowForgotPassword}) => {

    const [sent,setSent] = useState(false);
    const [result,setResult] = useState('');
    const [pressed,setPressed] = useState(false);
    const [email,setEmail] = useState('');
    const [error,setError] = useState(false);

    function setRecovery() {

        const headers = {
            method:'post',
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({username:email,email, host:window.location.host, protocol:window.location.protocol})
        }

        fetch(FunctionsData.getApiUrl('/api/search/vet/recover'), headers)
            .then ((r) => r.json())
            .then ((res) => {
                console.log(res);
                setResult(
                    (!res.error) ?
                        'We\'ve received your request, and will send you an email with the recovery details. You can now return to the login page.'
                        : <>Nothing could be found, click <a href={""} onClick={(e) => {e.preventDefault();setSent(false);}}>here</a> to try again.</>)
                setError((!res.error) ? false : "Nothing could be found");
                setSent((!res.error));
                setPressed(!(res.error) );
            })

    }

    return (
        <div className={"login-parent"} style={{textAlign:'center',verticalAlign: 'middle', height:'100vh', width:'100%'}}>

            <div style={{width:300, marginTop:300, marginLeft:'calc(50% - 150px)'}}>
                {
                    (sent === false) ?
                        <>
                            {
                                (error) ?
                                    <div style={{color:'red'}}>{error}</div>
                                    : undefined
                            }
                            <TextField placeholder={"Your username"}
                                       className={"form-control"}
                                       style={{width:'100%',marginBottom:20}}
                                       value={email}
                                       onChange={(e) => setEmail(e.target.value)}
                                       error={email === ''}
                            />
                            <Button variant={"contained"} disabled={pressed} className="btn-main-login" style={{width: '100%'}} type="submit" onClick={() => {
                                setPressed(true);
                                setRecovery();
                            }
                            }>
                                Recover password
                            </Button>
                        </>
                        :
                        <div>
                            {result}
                        </div>
                }

            </div>
            <div style={{marginTop:20}}>
                <a href={"#"} onClick={(e) => {
                    e.preventDefault();
                    setShowForgotPassword(false)
                }}>Back to the login page</a>
            </div>
        </div>
    )
}
